import { Vec2, dist, lerp } from './vec';

export class Path {
  readonly length: number;
  private readonly pts: Vec2[];
  private readonly cum: number[]; // cumulative distance at each waypoint

  constructor(waypoints: Vec2[]) {
    if (waypoints.length < 2) throw new Error('Path needs >= 2 waypoints');
    this.pts = waypoints;
    this.cum = [0];
    for (let i = 1; i < waypoints.length; i++) {
      this.cum.push(this.cum[i - 1] + dist(waypoints[i - 1], waypoints[i]));
    }
    this.length = this.cum[this.cum.length - 1];
  }

  pointAt(distance: number): Vec2 {
    const d = Math.max(0, Math.min(distance, this.length));
    for (let i = 1; i < this.cum.length; i++) {
      if (d <= this.cum[i]) {
        const segLen = this.cum[i] - this.cum[i - 1];
        const t = segLen === 0 ? 0 : (d - this.cum[i - 1]) / segLen;
        return lerp(this.pts[i - 1], this.pts[i], t);
      }
    }
    return this.pts[this.pts.length - 1];
  }
}
